import {FullCalendarReact} from "~/components";

function Schedule() {
    return (
        <FullCalendarReact />
    )
}
export default Schedule;